import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { assertScaleDefaults } from '@workflow/ui'
import '@workflow/ui/fonts.css'
import './index.css'
import { App } from '@/app/App'
import { applyAppearance } from '@/features/appearance/appearance'

// Compare the CSS and TypeScript defaults before the stored preference
// overwrites the CSS value, then apply the preference before first paint so
// the page never flashes the wrong theme or size.
assertScaleDefaults(import.meta.env.DEV)
applyAppearance()

const container = document.getElementById('root')
if (!container) throw new Error('Missing #root element')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
